(ns admin.containers.curriculum.reports.core
  (:require [re-frame.core :as re-frame]
            [cemerick.url :refer [map->query]]
            [potpuri.core :as pot]
            [kyber.lib.kyber-db :as kyber-db]
            [admin.containers.curriculum.reports-readiness.curriculum-learners-readiness
             :as curriculum-learners-readiness]
            [admin.containers.curriculum.reports-readiness.curriculum-readiness-breakdown
             :as curriculum-readiness-breakdown]
            [admin.containers.curriculum.reports-readiness.shared :as s]
            [admin.events.containers.curriculum-reports :as curriculum-reports]
            [admin.router.utils :as aru]
            [admin.constants :as c]
            [kyber.utils :as ku]
            [kyber.components.base.icons :as icon]
            [kyber.components.base.button :as button]
            [kyber.components.composite.loading :as loading]
            [kyber.components.base.text :as text]
            [kyber.components.composite.checkbox :as checkbox]
            [kyber.components.composite.dropdown :as dropdown]
            [kyber.components.composite.progress-bar :as progress-bar]
            [kyber.styles.core :refer [gs styles->classes]]))

(def classes
  (styles->classes
   {:container
    {:margin    [(gs [:spacing :p20]) :auto]
     :padding   [(gs [:spacing :p2])
                 (gs [:spacing :p20])]
     :display :grid
     :max-width (str c/page-max-width "px")}

    :dropdown-wrapper
    {"& > div"
     {:margin [(gs [:spacing :p0])
               (gs [:spacing :p0])
               (gs [:spacing :p12])]}}

    :items-center
    {:display     :flex
     :align-items :center}

    :main-header
    {:display         :flex
     :width           "100%"
     :justify-content :space-between
     :margin-bottom   (gs [:spacing :p20])
     (gs [:queries :mobile-landscape])
     {:display :block}}

    :responsive-half-column
    {:width "33.333%"
     (gs [:queries :tablet])
     {:width "45%"}
     (gs [:queries :mobile-landscape])
     {:width "100%"}}

    :filter-collection-container
    {:display         :flex
     :justify-content :space-between
     :width           "100%"
     :padding-right   (gs [:spacing :p20])

     "& > *"
     {:width "calc(50% - 20px)"}}
    :scale
    {:display :grid
     :justify-content :end}
    :inner-legend
    {:margin-left  (gs [:spacing :p8])
     :margin-right (gs [:spacing :p8])
     :width        (gs [:spacing :p170])}

    :key-options-container
    {:display     :flex
     :align-items :center
     :flex-direction :row
     :width "100%"
     :margin-bottom (gs [:spacing :p12])}

    :key-container
    {:border (str "1px solid " (gs [:colors :gray-scale-300]))
     :border-radius :r7
     :margin-top (gs [:spacing :p12])
     :margin-bottom (gs [:spacing :p12])
     :padding-right (gs [:spacing :p12])
     :max-width (gs [:spacing :p270])}

    :key-row
    {:display     :flex
     :align-items :center
     :justify-content :start}

    :key-text
    {:margin-left (gs [:spacing :p8])}

    :options-row
    {:margin-left (gs [:spacing :p8])}

    :csv-button-container
    {:display :flex
     :flex-direction :column
     :align-items :flex-end}}))

(defn- readiness-legend []
  [:div {:class (:items-center classes)}
   [text/caption-30 :p {:style {:white-space :nowrap}} "Least Ready"]
   [:div {:class (:inner-legend classes)}
    [s/readiness-scale {:distribution [1 1 1 1 1 1 1 1 1 1]
                        :height       :p8}]]
   [text/caption-30 :p {:style {:white-space :nowrap}} "Most Ready"]])

(defn- tag-group-filter
  [{:keys [tag-group make-new-query-params context curriculum-uuid 
           tags-with-registrations]}]
  (let [tag-group-name (:content-provider.tag-group/name tag-group)
        tag-group-uuid (:content-provider.tag-group/uuid tag-group)
        options (mapv (fn [{:content-provider.tag/keys [uuid name]}]
                        {:display name
                         :value uuid})
                      (:content-provider.tag-group/values tag-group))]
    (fn [{:keys [query-params]}]
      (let [selected-tag (get (:tag-groups query-params) tag-group-uuid)]
        [:div
         [text/caption-10 :p (str "Filter By " tag-group-name)]
         [:div {:class (:dropdown-wrapper classes)}
          [dropdown/render
           {:value selected-tag
            :no-selection-text "All"
            :options (sort-by :display options)
            :tag-group-name tag-group-name
            :tags-with-registrations tags-with-registrations
            :on-change
            (fn [tag-uuid]
              (let [new-tag-groups (assoc (:tag-groups query-params) tag-group-uuid tag-uuid)
                    new-query-params (make-new-query-params
                                      (fn [current-query-params]
                                        (cond-> (pot/deep-merge current-query-params {:tag-groups new-tag-groups
                                                                                      :current-page 0})
                                          (nil? tag-uuid)
                                          (update :tag-groups dissoc tag-group-uuid))))
                    new-context (assoc context :query new-query-params)]
                (re-frame/dispatch [:router/nav-to
                                    (str (aru/admin-path :curriculum-reports
                                                         :curriculum-uuid curriculum-uuid)
                                         "?" (map->query new-query-params))])
                (re-frame/dispatch [::curriculum-reports/async-fetch-learners-request-id
                                    new-context])))}]]]))))

(defn- tag-group-filters
  [{:keys [tag-groups] :as props}]
  [:div {:class [(:responsive-half-column classes)
                 (:filter-collection-container classes)]}
   (for [tag-group tag-groups]
     (when (seq (:content-provider.tag-group/values tag-group))
       ^{:key (:content-provider.tag-group/uuid tag-group)}
       [tag-group-filter (assoc props
                                :tag-group tag-group)]))])

(defn- published-filter
  [{:keys [curriculum-uuid query-params make-new-query-params context]}]
  [checkbox/render-v2
   {:default-value (:include-unpublished? query-params)
    :label "Show unpublished activities?"
    :on-change (fn [value]
                 (let [new-query-params (make-new-query-params
                                         (fn [current-query-params]
                                           (merge current-query-params {:include-unpublished? value})))
                       new-context (assoc context :query new-query-params)]
                   (re-frame/dispatch [:router/nav-to
                                       (str (aru/admin-path :curriculum-reports
                                                            :curriculum-uuid curriculum-uuid)
                                            "?" (map->query new-query-params))])
                   (re-frame/dispatch [::curriculum-reports/async-fetch-learners-request-id
                                       new-context])))}])

(defn render
  [{{curriculum-uuid :curriculum-uuid} :params :as context} _]
  (re-frame/dispatch [::curriculum-reports/clear-csv-report-message])
  (let [query
        (re-frame/subscribe [:router/route-query])

        curriculum
        (re-frame/subscribe
         [::kyber-db/get-record {:model :curriculum
                                 :ident curriculum-uuid}])]

    (fn [{:keys [resource-status]}]
      (let [<-xforms
            {:page-size js/parseInt
             :current-page js/parseInt
             :sort-order keyword
             :sort-key keyword
             :tag-groups aru/parse
             :include-unpublished? aru/parse-boolean}

            xforms->
            {:sort-order name
             :sort-key name
             :tag-groups aru/stringify
             :include-unpublished? str}

            {:keys [sort-order sort-key]
             :or {sort-key :average_readiness
                  sort-order :desc}
             :as query-params}
            (aru/xform-query
             {:query @query
              :xforms <-xforms})

            make-new-query-params
            #(let [current-query-params
                   (aru/xform-query
                    {:query (aru/get-query-params)
                     :xforms <-xforms})

                   new-query-params
                   (aru/xform-query
                    {:query ((partial % current-query-params))
                     :xforms xforms->})]
               (pot/map-keys name new-query-params))

            {{starters :curriculum.starters/edges
              page-info :curriculum.starters/page-info
              tags-with-registrations :curriculum.starters/tags-with-registrations}
             :curriculum/starters

             tag-groups :curriculum/valid-tags}
            @curriculum

            is-polling?
            (re-frame/subscribe [:kyber.subscriptions.async-request/is-polling?
                                 ::curriculum-reports/async-fetch-learners-request])]

        (if (and (not @is-polling?)
                 (ku/all-resources-loaded? resource-status))
          [:div {:class (:container classes)}
           [:div {:class (:main-header classes)}
            (when (seq tag-groups)
              [tag-group-filters {:curriculum-uuid curriculum-uuid
                                  :tag-groups tag-groups
                                  :query-params query-params
                                  :make-new-query-params make-new-query-params
                                  :context context
                                  :tags-with-registrations tags-with-registrations}])
            [:div {:class (:responsive-half-column classes)}
             [text/caption-10 :p "Readiness Scale:"]
             [readiness-legend]]]
           [curriculum-readiness-breakdown/render
            {:collection-title "Activities"
             :collection      (:curriculum.starters/cached-stats @curriculum)}]
           [:div {:style {:display :flex
                          :justify-content :space-between
                          :align-items :center
                          :margin-bottom (gs [:spacing :p16])}}
            [text/title-30 :p "Learners"]
            (let [is-super-user? (re-frame/subscribe [:authentication/has-access?
                                                       :is-super-user])
                  is-generating (re-frame/subscribe [:kyber.subscriptions.async-request/is-polling?
                                                      ::curriculum-reports/async-generate-csv-report])
                  csv-report-message (re-frame/subscribe [:curricula/csv-report-message])]
              (when (true? @is-super-user?)
                [:div {:class (:csv-button-container classes)}
                 [button/primary-button
                  {:disabled @is-generating
                   :on-click #(re-frame/dispatch [::curriculum-reports/generate-csv-report
                                                  {:curriculum/uuid curriculum-uuid}])}
                  (if @is-generating
                    "Generating..."
                    "Email CSV Report")]
                 (cond
                   @is-generating
                   [:div {:style {:align-self :flex-start
                                  :margin-top (gs [:spacing :p8])}}
                    [text/caption-30 :p {:style {:color (gs [:colors :gray-scale-500])}}
                     "This may take several minutes. You'll receive an email when your report is ready."]
                    [:div {:style {:margin-top (gs [:spacing :p8])}}
                     [progress-bar/loading-simulation]]]

                   (some? @csv-report-message)
                   [:div {:style {:align-self :flex-start
                                  :margin-top (gs [:spacing :p8])}}
                    [text/caption-30 :p {:style {:color (gs [:colors :gray-scale-500])}}
                     @csv-report-message]])]))]
           [:div {:class (:dropdown-wrapper classes)}
            [dropdown/render
             {:value     {:sort-key   (some-> sort-key name)
                          :sort-order (some-> sort-order name)}
              :options   [{:display "Most Ready"
                           :value   {:sort-key   "average_readiness"
                                     :sort-order "desc"}}
                          {:display "Least Ready"
                           :value   {:sort-key   "average_readiness"
                                     :sort-order "asc"}}
                          {:display "Highest Mindset"
                           :value   {:sort-key   "average_mindset"
                                     :sort-order "desc"}}
                          {:display "Lowest Mindset"
                           :value   {:sort-key   "average_mindset"
                                     :sort-order "asc"}}]
              :on-change (fn [new-sort]
                           (let [new-query-params (make-new-query-params #(merge % new-sort {:current-page 0}))
                                 new-context (assoc context :query new-query-params)]
                             (re-frame/dispatch [:router/nav-to
                                                 (str (aru/admin-path :curriculum-reports
                                                                      :curriculum-uuid curriculum-uuid)
                                                      "?" (map->query new-query-params))])
                             (re-frame/dispatch [::curriculum-reports/async-fetch-learners-request-id
                                                 new-context])))}]]
           [:div {:class (:key-options-container classes)}
            [:div {:class (:key-container classes)}
             [:div {:class (:key-row classes)}
              [text/title-10 :p {:style {:width (gs [:spacing :p40])
                                         :padding-left (gs [:spacing :p6])}}
               "Key:"]
              [:div {:style {:width (gs [:spacing :p20])}}
               [icon/icon-sm
                {:style {:color (gs [:colors :chart-green])}
                 :title "All required activities complete"}
                :check-circle]]
              [text/caption-10 :p {:class (:key-text classes)} "All required activities complete"]]
             [:div {:class (:key-row classes)}
              [:div {:style {:width (gs [:spacing :p40])}}]
              [:div {:style {:width (gs [:spacing :p20])}}
               [icon/icon-sm
                {:style {:color (gs [:colors :chart-orange])}
                 :title "Some required activities incomplete"}
                :warning-triangle]]
              [text/caption-10 :p {:class (:key-text classes)} "Some required activities incomplete"]]]
            [:div {:class (:options-row classes)}
             [published-filter {:query-params query-params
                                :make-new-query-params make-new-query-params
                                :context context
                                :curriculum-uuid curriculum-uuid}]]]
           [curriculum-learners-readiness/render
            {:users                 starters
             :curriculum-uuid       curriculum-uuid
             :using-tags?           (some #(-> % :content-provider.tag-group/values seq) tag-groups)
             :tag-group-names       (map :content-provider.tag-group/name tag-groups)
             :page-info             page-info
             :query-params          query-params
             :make-new-query-params make-new-query-params
             :context               context}]]
          [loading/render
           {:loading-message "Please wait while we fetch your reports"}])))))
